import { client } from '@app/data/iron';

const GET_PRODUCT_QUERY = async ({ queryKey }) => {
  const [, { currency, id, market, country }] = queryKey;
  const { data } = await client.get(`/api/products/${id}?includes=market,360`, {
    params: { market, currency, country },
  });

  return data;
};

export default GET_PRODUCT_QUERY;
